export default {
  name: ['权限组名称', 'Role Name'],
  name_zh_cn: ['中文为空', 'Chinese empty'],
  name_en_us: ['英文为空', 'English empty'],
  namePlaceholder: ['请输入权限组名称', 'Please Enter Role Name'],
  nameRequire: ['当前权限组名称不能为空', 'Current Role Name cannot be empty'],
  key: ['权限组代码', 'Role Code'],
  keyPlaceholder: ['请输入权限组代码', 'Please Enter Role Code'],
  keyRequire: ['当前权限组代码不能为空', 'Current Role Code cannot be empty'],
  keyDuplicated: ['当前权限组代码已存在', 'Current Role Code already exists'],
  resource: ['资源策略', 'Resource Policy'],
  checked: ['选中', 'Checked'],
  unchecked: ['取消', 'UnChecked'],
  expand: ['展开', 'Expand'],
  close: ['收起', 'Close'],
  permission: ['特殊授权', 'Permission'],
  permissionPlaceholder: ['请选择特殊授权代码', 'Please select permission key'],
  note: ['备注', 'Note']
};
